export default __webpack_public_path__ + "static/media/circle_event_top.140783fa.svg";